import React, { Suspense, lazy } from 'react';
import { store, Provider } from './redux-saga/store';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Spinner from './components/Loader';
import './App.css';
import Settings from './pages/setting';
import ProjectFilePage from './pages/ProjectFiles';
import ProjectAssignees from './pages/ProjectAssignees';
import Configurables from './pages/configuration';
import KnowledgeBase from './pages/KnowledgeBase';
import KnowledgeBaseDetails from './pages/KnowledgeBaseDetails';
import DepartmentPage from './pages/DepartmentPage';
import PatientPage from './pages/PatientPage';
import InsurancePage from './pages/InsurancePage ';
import VisitPage from './pages/VisitPage';
import EncounterPage from './pages/EncounterPage';
import DiagnosisPage from './pages/DiagnosisPage';
import ServicePage from './pages/ServicePage';
import IcdPage from './pages/IcdPage';
import CptPage from './pages/CptPage ';
import HcpcPage from './pages/HcpcPage';
import ClaimPage from './pages/ClaimPage';
import IcdAgents from './pages/icdAgents';


// Lazy loading components
const NavBar = lazy(() => import('./components/NavBar'));
const Patient = lazy(() => import('./pages/PatientPage'));
const Login = lazy(() => import('./pages/Login'));
const Department = lazy(() => import('./pages/DepartmentPage'));
const Payer = lazy(() => import('./pages/PayerPage'));
const Statepages = lazy(() => import('./pages/StatePage'));
const ViewBatch = lazy(() => import('./pages//viewBatch'));
const Rules = lazy(() => import('./pages//RulePage'));
const Physician = lazy(() => import('./pages/PhysicianPage'));
const Home = lazy(() => import('./pages/Home'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Batch = lazy(() => import('./pages/Batch'));
const Users = lazy(() => import('./pages/Users'));
const Repo = lazy(() => import('./pages/Repository'));
const Group = lazy(() => import('./pages/Group'));
const BatchGrouping = lazy(() => import('./pages/BatchGrouping'));
const ViewProject = lazy(() => import('./pages/ViewProject'));
const FilePage = lazy(() => import('./pages/RepoFiles'));
const Agent = lazy(() => import('./pages/Agents'))
const Prompt = lazy(() => import('./pages/Prompt'))
const TestCases = lazy(() => import('./pages/TestCases'))
const ApiKey = lazy(() => import('./pages/ApiKey'))
const Process = lazy(() => import('./pages/process'))
function App() {
  return (
    <Provider store={store}>
      <Router>
        <div>
          <Suspense fallback={<Spinner />}>
            <div style={{ padding: '20px' }}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/agents"
                  element={
                    <PrivateRoute>
                      <Agent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/apikeys"
                  element={
                    <PrivateRoute>
                      <ApiKey />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/prompts"
                  element={
                    <PrivateRoute>
                      <Prompt />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='/testcases'
                  element={
                    <PrivateRoute>
                      <TestCases />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='/process'
                  element={
                    <PrivateRoute>
                      <Process />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/batch/:id"
                  element={
                    <PrivateRoute>
                      <Batch />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/team"
                  element={
                    <PrivateRoute>
                      <Users />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/knowledgebase"
                  element={
                    <PrivateRoute>
                      <KnowledgeBase />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/icd-agents"
                  element={
                    <PrivateRoute>
                      <IcdAgents />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/config"
                  element={
                    <PrivateRoute>
                      <Configurables />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/repo"
                  element={
                    <PrivateRoute>
                      <Repo />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/repo/:id"
                  element={
                    <PrivateRoute>
                      <FilePage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/group"
                  element={
                    <PrivateRoute>
                      <Group />
                    </PrivateRoute>
                  }
                />

                <Route path="/knowledge-base/:kbId/details" element={<KnowledgeBaseDetails />} />

                <Route
                  path="/config"
                  element={
                    <PrivateRoute>
                      <Configurables />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/batch/:id"
                  element={
                    <PrivateRoute>
                      <ViewBatch />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="project/files/:id"
                  element={
                    <PrivateRoute>
                      <ProjectFilePage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/assignees/:id"
                  element={
                    <PrivateRoute>
                      <ProjectAssignees />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/department/:id"
                  element={
                    <PrivateRoute>
                      <Department />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/physician/:id"
                  element={
                    <PrivateRoute>
                      <Physician />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/payer/:id"
                  element={
                    <PrivateRoute>
                      <Payer />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="project/patient/:id"
                  element={
                    <PrivateRoute>
                      <Patient />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/insurance/:projectId"
                  element={
                    <PrivateRoute>
                      <InsurancePage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="project/visit/:projectId"
                  element={
                    <PrivateRoute>
                      <VisitPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/encounter/:projectId"
                  element={
                    <PrivateRoute>
                      <EncounterPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/diagnosis/:projectId"
                  element={
                    <PrivateRoute>
                      <DiagnosisPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/service/:projectId"
                  element={
                    <PrivateRoute>
                      <ServicePage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/icd/:projectId"
                  element={
                    <PrivateRoute>
                      <IcdPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/hcpc/:projectId"
                  element={
                    <PrivateRoute>
                      <HcpcPage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="project/claims/:projectId"
                  element={
                    <PrivateRoute>
                      <ClaimPage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="project/cpt/:projectId"
                  element={
                    <PrivateRoute>
                      <CptPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/rules/:id"
                  element={
                    <PrivateRoute>
                      <Rules />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="project/state/:id"
                  element={
                    <PrivateRoute>
                      <Statepages />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:id"
                  element={
                    <PrivateRoute>
                      <ViewProject />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/batch-group/:recordId"
                  element={
                    <PrivateRoute>
                      <BatchGrouping />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <PrivateRoute>
                      <Settings />
                    </PrivateRoute>
                  }
                />
                <Route path="*" element={<Home />} />
              </Routes>
            </div>
          </Suspense>
        </div>
      </Router>
    </Provider>
  );
}

export default App;